<div class="f-row custom-dialog">
  <div class="container d-justify-bw">
    <div class="verify-title">
      <div class="title">
        <h3 class="title-text">Add Supplier</h3>
        <span class="sub-title"> Select all the supplier you want to add</span>
      </div>
      <div class="close">
        <button aria-label="close button" mat-icon-button>
          <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
        </button>
      </div>
    </div>

    <div class="f-col d-align-center verify-body">
      <mat-chip-set class="chip-rows">
        <mat-chip>Air Asia domestic</mat-chip>
        <mat-chip>Akasa Retail</mat-chip>
        <mat-chip class="selected">
          Air India
          <button aria-label="chip remove button" matChipRemove>
            <mat-icon fontSet="material-symbols-outlined">check</mat-icon>
          </button>
        </mat-chip>
        <mat-chip disabled>Saudia Airlines</mat-chip>
      </mat-chip-set>
    </div>

    <div class="f-col d-align-right verify-footer">
      <button mat-button class="button--primary-small">Add</button>
    </div>
  </div>
</div>
